import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/Users/joseph/projects/moneyline/client/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.mjs");
